import { produce } from 'immer';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import { AssetFilter } from 'app/lib/constants';
import type { SnowflakeSchemaFqn } from 'app/lib/types/server';
import { SELECT_TARGET, UPDATE_ASSET_FILTER } from './types.js';

export type AssetsSlice = {
    selectedTargetFqn: null | SnowflakeSchemaFqn;
    assetFilter: AssetFilter;
};

export const INITIAL_STATE: AssetsSlice = {
    selectedTargetFqn: null,
    assetFilter: AssetFilter.ALL
};

export const assetsReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case UPDATE_ASSET_FILTER:
            draft.assetFilter = action.payload.filter;
            break;
        case SELECT_TARGET:
            draft.selectedTargetFqn = action.payload.fqn;
            break;
        default:
    }
}, INITIAL_STATE);
